import * as React from 'react';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {ExternalMeetingFragment} from 'nutshell-graphql-types';

import {NoIntegrationsEmptyState} from '../../calls/no-integrations-empty-state';

import {FirstLoadUnloggedTableEmptyState} from '../first-load-unlogged-table-empty-state';

import {EmptyUnloggedInbox} from './empty-unlogged-inbox';
import {InitialSyncEmptyState} from './initial-sync-empty-state';
import type {ExternalServiceTypeFrontend} from './types';

type Props = {
    totalCount: number;
    isPerformingInitialSync: boolean;
    firstEnabledIntegrationType: ExternalServiceType | null | undefined;
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    hasLoggedMeetings: boolean;
    meetings: ExternalMeetingFragment[];
};

export function UnloggedTableEmptyState(props: Props) {
    if (props.totalCount === 0 && !props.hasLoggedMeetings) {
        if (props.serviceType === 'PHONES' && !props.firstEnabledIntegrationType) {
            return <NoIntegrationsEmptyState />;
        }

        if (props.isPerformingInitialSync && props.firstEnabledIntegrationType) {
            return <InitialSyncEmptyState integrationType={props.firstEnabledIntegrationType} />;
        }
    }

    if (props.meetings.length > 0) {
        return <EmptyUnloggedInbox serviceType={props.serviceType} />;
    }

    return (
        <FirstLoadUnloggedTableEmptyState
            serviceType={props.serviceType}
            hasLoggedMeetings={props.hasLoggedMeetings}
            firstEnabledIntegrationType={props.firstEnabledIntegrationType}
        />
    );
}
